var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.readyClass},[_c('AppBar'),_c('v-main',{staticClass:"pt-0"},[_c('router-view'),_c('LffFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }